import { render, staticRenderFns } from "./ApprovalTableBase.vue?vue&type=template&id=dc1107b8"
import script from "./ApprovalTableBase.vue?vue&type=script&lang=ts"
export * from "./ApprovalTableBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports